.gr{border:1px solid #ddd;}